<template>
  <wh-popup
    v-model="myVisible"
    title="加工过程"
    :ref-form="$refs.ProcessPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="ProcessPopup"
      class="process-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <van-steps direction="vertical" :active="(form.processingJson.processingProcessInfo||[]).length" active-color="#20CAA0">
        <van-step v-for="( item , key ) in form.processingJson.processingProcessInfo" :key="item.id">
          <template v-slot:inactive-icon>
            <div class="inactive">
              {{ key + 1 }}
            </div>
          </template>
          <van-cell>
            <div class="step-item wh-flex-start">
              <van-image class="img" width="48" height="48" fit="fill" :src="item.photo|firstImgThumb">
                <template v-slot:error>
                  <div class="error-img">
                    暂无图片
                  </div>
                </template>
              </van-image>
              <div class="name">
                <span>{{ item.processName }}</span>
                <span>操作人：{{ item.staffName }}</span>
              </div>
            </div>
            <template #right-icon>
              <van-checkbox v-model="item.flag" />
            </template>
          </van-cell>
        </van-step>
      </van-steps>
    </van-form>
  </wh-popup>
</template>
<script>
import { firstImgThumb } from '@/filter'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formPopup } from '@/utils/mixins/formPopup'
import { formatTime } from '@/utils/convert/convertTime'
export default {
  components: { WhPopup },
  filters: {
    firstImgThumb
  },
  mixins: [formPopup],
  data() {
    return {
      form: {
        processingJson: {}
      }
    }
  },
  methods: {
    formatTime,
    open() {
      this.formDataInit(this.form, this.initFormData)
      this.form.processingJson.processingProcessInfo.map(i => {
        if (!i.hasOwnProperty('flag')) {
          this.$set(i, 'flag', false)
        }
      })
      console.log(this.form.processingJson.processingProcessInfo)
    },
    submitForm() {
      this.$emit('confirm', this.form)
      this.hidePopup()
    }
  }
}
</script>
<style lang="less" scoped>
.process-popup{
   padding: 10px 16px;
  .inactive{
  background-color: #20CAA0;
  color: #fff;
  margin-top: 80px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
}
/deep/ .van-step--vertical .van-step__line{
  width:2px;
  left: -16px;
  top: 51px;
}
/deep/ .van-step:last-child .van-step__line{
  width: 0;
}
  .step-item{
      background-color: #F8F8F8;
      height: 80px;
      padding-left: 20px;
      .img{
        margin-top: 5px;
      }
      .name{
      display: flex;
      margin-left: 15px;
      flex-direction: column;
      height: 40px;
      justify-content: space-between;
      span:nth-child(1){
        font-size: 14px;
        font-weight: bold;
        color: #323332;
      }
      span:nth-child(2){
        color: #BBBBBB;
        font-size: 12px;
      }
    }
  }
}
</style>
